<template>
  <div class="purchaseOrder">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="采购订单详情"
        class="customer-edit"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="purchase"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <table class="gridtable" style="width: 100%;" cellpadding="0" cellspacing="0">
          <tr>
            <td class="tableLabel">采购订单号:</td>
            <td style="width: 23%">{{purchase.buyOrderNo}}</td>
            <td class="tableLabel">下单时间:</td>
            <td style="width: 23%">{{purchase.addDate}}</td>
            <td class="tableLabel">创建时间:</td>
            <td>{{purchase.createdTime}}</td>
          </tr>
          <tr>
            <td class="tableLabel">供应商:</td>
            <td>{{purchase.gysName}}</td>
            <td class="tableLabel">供应商代码:</td>
            <td>{{purchase.gysCode}}</td>
            <td class="tableLabel">联系人:</td>
            <td>{{purchase.linkMan}}</td>
          </tr>
          <tr>
            <td class="tableLabel">电话:</td>
            <td>{{purchase.linkManPhone}}</td>
            <td class="tableLabel">传真:</td>
            <td colspan="3">{{purchase.linkManFax}}</td>
          </tr>
        </table>
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="物料信息" name="first">
            <el-table
                :data="purchase.details"
                border
                style="width: 100%">
              <el-table-column prop="rowNum" align="center" label="序号" width="90"/>
              <el-table-column prop="partNo" align="center" label="物料编号" width="90"/>
              <el-table-column
                  prop="partNameSpec"
                  align="center"
                  label="物料名称"
                  min-width="320"
                  show-overflow-tooltip/>
              <el-table-column prop="requireDeliveryDate" align="center" label="采购订单交期" width="120">
                <template slot-scope="scope">
                  <span>{{scope.row.requireDeliveryDate.slice(0,10)}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="qty" align="center" label="采购数量" width="90"/>
              <!--              <el-table-column prop="hasReceiveQty" align="center" label="已购数量" width="90"/>-->
              <!--              <el-table-column prop="hasInStorageQty" align="center" label="送货数量" width="90"/>-->
              <el-table-column
                  prop="responseDeliveryTime"
                  align="center"
                  label="回复交期"
                  width="180">
                <template v-slot="scope">
                  <el-date-picker
                      v-if="(receiveStatus === 0 || receiveStatus === 1) && scope.row.poStatus !== 30"
                      v-model="scope.row.responseDeliveryTime"
                      :disabled="userType === 1"
                      style="width: 150px"
                      align="center"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="date"
                      placeholder="选择日期"/>
                  <span v-else>{{scope.row.responseDeliveryTime ? scope.row.responseDeliveryTime.slice(0,10) : ""}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  v-if="receiveStatus === 2"
                  label="交期确认"
                  align="center"
                  width="180">
                <template v-slot="scope">
                  <el-radio-group v-model="scope.row.poStatus" :disabled="userType === 2">
                    <el-radio :label="10">退回</el-radio>
                    <el-radio :label="30">确认</el-radio>
                  </el-radio-group>
                </template>
              </el-table-column>
              <el-table-column
                  prop="remark"
                  align="center"
                  label="备注"
                  width="200"/>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="附件信息" name="second">
            <el-table
                :data="tableData"
                border
                style="width: 100%">
              <el-table-column prop="nodeDesc" label="节点名称" align="center" width="160"/>
              <el-table-column prop="category" label="文件分类" align="center" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.category === 0">公开</span>
                  <span v-else>受控</span>
                </template>
              </el-table-column>
              <el-table-column prop="fileName" align="center" label="文件名" min-width="160"/>
              <el-table-column prop="creatorAccountName" align="center" label="创建者" width="100"/>
              <el-table-column prop="createdTime" align="center" width="150" label="创建时间"/>
              <el-table-column prop="note" align="center" label="备注"/>
              <el-table-column
                  label="操作"
                  align="center"
                  class-name="vm-table_operate">
                <template slot-scope="scope">
                  <el-button type="primary" @click="download(scope.row)">下载</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="供应商上传附件" name="third">
            <el-upload
                action=""
                :http-request="submitUpload"
                :file-list="files"
                :show-file-list="false"
                style="float: left; margin-right: 5px">
              <el-button :v-loading="uploadLoading" type="primary" style="margin-bottom: 10px"> 添加附件</el-button>
            </el-upload>
            <el-table
                :data="supplierData"
                border
                style="width: 100%">
              <el-table-column prop="fileName" align="center" label="文件名" min-width="160"/>
              <el-table-column prop="note" align="center" label="备注" width="400"/>
              <el-table-column
                  label="操作"
                  align="center">
                <template slot-scope="scope">
                  <el-button type="primary" @click="downloadSupplierFile(scope.row)">下载</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>
      <span slot="footer">
        <template>
          <el-button
              v-if="receiveStatus < 2"
              :disabled="userType === 1"
              type="primary"
              :loading="saveLoading"
              @click="handleSave">保存</el-button>
          <el-button
              v-if="receiveStatus < 5"
              :disabled="submitDisable"
              type="warning"
              :loading="submitLoading"
              @click="handleSubmit">提交</el-button>
        </template>
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import LoginUtil from "@/util/loginUtil";
  import loginUtil from "@/util/loginUtil";

  export default {
    name:"Preview",
    components: {},
    data() {
      return {
        uploadAuth: this.$auth(454),
        downloadAuth: this.$auth(459),
        constant,
        uploadLoading:false,
        userType:LoginUtil.getUserType(),
        statu:constant.toSelect(constant.purchaseStatus,"addAll"),
        dialogVisible: false,
        contentLoading: false,
        saveLoading: false,
        submitLoading: false,
        submitDisable: true,
        tableData: [],
        supplierData:[],
        receiveStatus: "",
        activeName: "first",
        files:[],
        purchase: {
          buyOrderNo: "",
          addDate: "",
          creatorName: "",
          createdTime: "",
          arrivedTime: "",
          gysName: "",
          gysCode: "",
          linkMan: "",
          linkManFax: "",
          linkManPhone: "",
          details: [],
          supplierFileList:[],
        },
        ruleValidate: {
          postName: {required: true, message: "不能为空",trigger: "blur"},
          parentName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(row) {
        this.receiveStatus = row.receiveStatus;
        this.handleResponseDeliveryTime(row.details);
        this.handleSubmitDisable();
        this.purchase = row;
        this.dialogVisible = true;
        this.getData(row.pkid);
      },
      getData(id) {
        if (this.purchase.techParamBillIdList === null) {
          return;
        }
        this.purchase.techParamBillIdList.forEach(item=>{
          this.$http.get("basic", `applications/attached/1/${item}`).then((resp) => {
            if(resp) {
              resp.forEach(item=> {
                if(item.category !== 0) {
                  this.tableData.push(item);
                }
              });
            }
          });
        });

        this.$http.get("basic", `sAPPurchaseOrders/${id}`).then((resp) => {
          console.log(resp);
          this.supplierData=resp.supplierFileList;
          this.handleResponseDeliveryTime(this.purchase.details);
        });
      },
      handleSave() {
        this.saveLoading = true;
        this.$http
          .put("basic", "sAPPurchaseOrders/responseDeliveryTime", this.purchase)
          .then(() => {
            this.saveLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("保存成功");
          })
          .catch(() => {
            this.saveLoading = false;
          });
      },
      handleSubmit() {
        this.submitLoading = true;
        this.$http
          .post("basic", "sAPPurchaseOrders/responseDeliveryTime", this.purchase)
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$emit("save-success");
            this.$message.success("提交成功");
          })
          .catch(() => {
            this.submitLoading = false;
          });
      },
      handleResponseDeliveryTime(details) {
        if (details === null) {
          return;
        }
        details.forEach(detail => {
          if (detail.responseDeliveryTime === null && this.receiveStatus < 2) {
            detail.responseDeliveryTime = detail.requireDeliveryDate;
          }
        });
      },
      handleSubmitDisable() {
        if (this.receiveStatus < 2) {
          this.submitDisable = this.userType === 1;
        } else if (this.receiveStatus === 2) {
          this.submitDisable = this.userType === 2;
        }
      },

      download(row) {
        let fileName = row.fileName;
        let a = document.createElement("a");
        a.href = window.config.fileServerUrl + row.filePath;
        a.target = "_blank";
        a.download = fileName;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },

      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());

        this.$http
          .post("basic", "sAPPurchaseOrders/supplierUploadPurchaseOrderFile/"+this.purchase.pkid,formData)
          .then(() => {
            this.uploadLoading = false;
            this.$message.success("上传成功");
            this.getData(this.purchase.pkid);
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },

      downloadSupplierFile(row) {
        let data = {
          name:row.fileName,
          uuid:row.filePath,
        };
        this.$http.exportFile("basic","file/download",data).then(res => {
          console.log(res);
          let blob = new Blob([res.data],{type:"application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .purchaseOrder{
    .el-form-item__content{
      margin-left: 2%!important;
    }
    table.gridtable {
      font-family: verdana,arial,sans-serif;
      font-size:11px;
      color:#333333;
      border: 1px solid #EBEEF5;
      border-bottom: none;
      border-left: none;
      margin-bottom: 15px;
    }
    table.gridtable tr td {
      padding: 8px;
      border-left: 1px solid #EBEEF5;
      border-bottom: 1px solid #EBEEF5;
    }
    .tableLabel {
      width: 10%;
      text-align: right;
      background-color: #D1E6F5;
      border-left: 1px solid #EBEEF5;
    }
  }

</style>
